import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';

import { EnvironmentService } from '../environment.service';
import * as SpecificationSearchModels from '../../models/specification/specificationSearch';
import * as SpecificationModels from '../../models/specification/specification';
import { SpecificationStatusesListModel } from '../../models/specification/specificationStatus';
import { HelperService } from '../helper/helper.service';

import * as Models from '../../models/commonModels';
import * as CarModels from '../../models/car/car';

@Injectable({
  providedIn: 'root'
})


export class SpecificationService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private helper: HelperService
  ) { }

  public getList(Search: SpecificationSearchModels.SpecificationSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();
    return this.httpClient.post<SpecificationModels.SpecificationListModel>(`${this.environmentService.getApiURL()}/specification/list`, Search, options);
  }


  public getSummary(Search: SpecificationSearchModels.SpecificationSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<SpecificationModels.SpecificationListSummaryModel>(
      `${this.environmentService.getApiURL()}/specification/list/summary`, Search, options
    );
  }

  public getStatusesDictionary() {
    return this.httpClient.get<SpecificationStatusesListModel>(`${this.environmentService.getApiURL()}/specification/status`);
  }

  public getReport(search: SpecificationSearchModels.SpecificationSearchModel, reportName: string, reportType?: string) {
    this.helper.consoleLog('getReport');

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };
    switch (reportName) {
      case 'filtered':
      case 'ReplacementAndSeasoning':
        this.helper.consoleLog(`${reportName} report`);
        return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/specification/report/${reportName}`, search, options);
        break;
      case 'detailed':
        reportType = reportType || 'GarageReport';
        this.helper.consoleLog('detailed report: ' + reportType);
        return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/specification/report/detailed/${reportType}`, search, options);
        break;
    }
  }

  public getCostReport(Search: SpecificationSearchModels.SpecificationSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/specification/cost-report`, Search, options);
  }

  public getAutoryzationCostReport(Search: SpecificationSearchModels.SpecificationSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/specification/autoryzation-cost-report`, Search, options);
  }

  public uploadFile(formData, option: string) {
    // !!! not working with headers
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'multipart/form-data')
      .set('Accept', 'application/json');

    let endpoint = 'details';
    if (option === 'importDetails') {
      endpoint = 'details';
    } else { // importChanges
      endpoint = 'changes';
    }

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post(`${this.environmentService.getApiURL()}/specification/list/upload/${endpoint}`, formData, { reportProgress: true, observe: 'events' });
  }

  public getPreviewList(Search: SpecificationSearchModels.SpecificationPreviewSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();
    return this.httpClient.post<Models.ResponseList<SpecificationModels.SpecificationPreviewModel>>(`${this.environmentService.getApiURL()}/specification/preview-list`, Search, options);
  }

  public importAutorization(Data: any) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/specification/import-autorization`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public getExchangeVerificationReport(Data: any) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/specification/report/exchange-verification`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public getExchangeServicesReport(Data: any) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/specification/report/exchange-services`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public getDetailedAfterSaleReport(Search: SpecificationSearchModels.SpecificationSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/specification/report-specification-detailed-after-sale`, Search, options);
  }

  public new(Specification: Models.Request<SpecificationModels.SpecificationModel>, FileUpload1: File, FileUpload2: File) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const formData = new FormData();

    if (FileUpload1 && FileUpload1.name) {
      formData.append("FileUpload1", FileUpload1, FileUpload1.name);
    }

    if (FileUpload2 && FileUpload2.name) {
      formData.append("FileUpload2", FileUpload2, FileUpload2.name);
    }

    formData.append('Specification', JSON.stringify(Specification));

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/new`, formData);
  }


  public set(Specification: Models.Request<SpecificationModels.SpecificationModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/set`, Specification, options);
  }

  public get(Specification: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/get`, Specification, options);
  }


  public newSpecificationDetail(Specification: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/new-specification-detail`, Specification, options);
  }

  public deleteSpecificationDetail(Specification: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/delete-specification-detail`, Specification, options);
  }

  public acceptSpecificationDetail(Specification: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/accept-specification-detail`, Specification, options);
  }

  public rejectSpecificationDetail(Specification: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/reject-specification-detail`, Specification, options);
  }

  public setSpecificationDetail(Specification: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/set-specification-detail`, Specification, options);
  }

  public setFile(Specification: Models.Request<SpecificationModels.SpecificationModel>, FileIndex: number, File: File) {

    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "multipart/form-data")
      .set("Accept", "application/json");

    const options = { headers: httpHeaders };

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);
    formData.append('Specification', JSON.stringify(Specification));
    formData.append("FileIndex", FileIndex.toString());

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/set-file`, formData);
  }

  public getFile(Specification: Models.ContextRequest<SpecificationModels.SpecificationModel, number>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');


    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/specification/get-file`, Specification, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public deleteFile(Specification: Models.ContextRequest<SpecificationModels.SpecificationModel, number>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/delete-file`, Specification, options);
  }

  public generateSpecyficationReport(Specyfication: Models.Request<SpecificationModels.SpecyficationReportModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/specification/report-pdf`, Specyfication, options);
  }

  public create(Specification: Models.Request<SpecificationModels.SpecificationModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const formData = new FormData();


    formData.append('Specification', JSON.stringify(Specification));

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/create`, formData);
  }

  public changeCar(Specification: Models.ContextRequest<SpecificationModels.SpecificationModel, CarModels.CarModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<SpecificationModels.SpecificationModel>>(`${this.environmentService.getApiURL()}/specification/change-car`, Specification, options);
  }

  public setSpecificationNote(SpecificationNote: Models.Request<SpecificationModels.SpecificationNoteModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<SpecificationModels.SpecificationNoteModel>>(`${this.environmentService.getApiURL()}/specification/set-specification-note`, SpecificationNote, options);
  }

  public getSpecificationNotes(Specification: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<SpecificationModels.SpecificationNoteModel>>(`${this.environmentService.getApiURL()}/specification/specification-notes`, Specification, options);
  }

  public setSpecificationDetailNote(SpecificationDetailNote: Models.Request<SpecificationModels.SpecificationDetailNoteModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<SpecificationModels.SpecificationDetailNoteModel>>(`${this.environmentService.getApiURL()}/specification/set-specification-detail-note`, SpecificationDetailNote, options);
  }

  public getSpecificationDetailNotes(SpecificationDetail: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<SpecificationModels.SpecificationDetailNoteModel>>(`${this.environmentService.getApiURL()}/specification/specification-detail-notes`, SpecificationDetail, options);
  }
}
